export const ERROR_DB = 'ERROR_DB';
export const GET_ALL_TXS = 'GET_ALL_TXS';
export const GET_TX = 'GET_TX';
export const GET_TX_BY_DATE = 'GET_TX_BY_DATE';
export const GET_TXS_BY_DATE = 'GET_TXS_BY_DATE';
export const TXS_SENT = 'TXS_SENT';
export const SET_SELL_DB = 'SET_SELL_DB';
export const TX_DELETED = 'TX_DELETED';
export const TX_FINISHED = 'TX_FINISHED';